import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';

export const RoadmapExplorerGoalRow = ({
  name, progress, goalAmount, goalDate, condensed,
}) => {
  return (
    <FDStack alignItems="center" justifyContent="space-between" flex={1} spacing={4}>
      <FDStack alignItems="center" spacing={1} flex={1}>
        {name}
      </FDStack>
      <FDStack alignItems="center" justifyContent="space-between" flex={1} spacing={1}>
        {progress}
        <FDStack spacing={1} justifyContent="flex-end">
          <FDStack justifyContent="flex-end" width={80}>
            {goalAmount}
          </FDStack>
          {condensed ? null : (
            <FDStack justifyContent="flex-end" width={50}>
              {goalDate}
            </FDStack>
          )}
        </FDStack>
      </FDStack>
    </FDStack>
  );
};

RoadmapExplorerGoalRow.propTypes = {
  name: PropTypes.node,
  progress: PropTypes.node,
  goalAmount: PropTypes.node,
  goalDate: PropTypes.node,
  condensed: PropTypes.bool,
};
